import { SET_IS_REGISTERED_ORG, SET_LOADING_ORG, SET_ORGANISATION_DATA } from "./organisation.constant";

/* Actions */
import { setIsRegisteredOrg, setLoadingOrg, setOrganisationData } from "./organisation.action";

const initialOrgData = {
  code: "",
  id: "",
  features: [],
  is_password_enabled: false,
  is_sso_enabled: false,
  logo: "",
  name: "",
  short_logo: "",
  sso_forgot_password_url: "",
  sso_login_url: "",
  sso_logout_url: "",
  sso_provider: "",
  sso_register_url: "",
  modules: [],
  isShipmentV1: false,
}

const initialState: Organisation = { isRegisteredOrg: false, isLoadingOrg: true, orgData: initialOrgData };

type OrganisationAction = ReturnType<typeof setIsRegisteredOrg | typeof setLoadingOrg | typeof setOrganisationData>;

export function organisationReducer(state = initialState, action: OrganisationAction): Organisation {
  switch (action.type) {
    case SET_IS_REGISTERED_ORG:
      return { ...state, isRegisteredOrg: action.payload };
    case SET_LOADING_ORG:
      return { ...state, isLoadingOrg: action.payload };
    case SET_ORGANISATION_DATA:
      return { ...state, orgData: action.payload };
    default:
      return state;
  }
}
